/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Any_Gray_Liger_TearInputs */

const fr_any_gray_liger_tear = /** @type {(inputs: Any_Gray_Liger_TearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PR`)
};

/**

* @param {Any_Gray_Liger_TearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const any_gray_liger_tear = /** @type {((inputs?: Any_Gray_Liger_TearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Any_Gray_Liger_TearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_any_gray_liger_tear(inputs)
});